import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { MessageService, SelectItem } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { FechasService } from 'src/app/services/fechas/fechas';
import { GenericService } from '../../../services/generic/generic.service';
import { siEsNull } from 'src/app/config/texto_comprobacion';
import { url } from 'src/app/config/config';
import { UploadService } from 'src/app/services/upload/upload.service';
import { Utils } from 'src/app/common/utils';
import { handleImageUpload } from 'src/app/config/compress_image';

@Component({
  selector: 'app-articulos-proveedor-create',
  templateUrl: './articulos-proveedor-create.component.html',
  styleUrls: ['./articulos-proveedor-create.component.css']
})
export class ArticulosProveedorCreateComponent implements OnInit {

  public fileName: string = 'imagen.jpg';
  public numberPhoto: number = 1;
  public showCamera: boolean = false;
  public es = Utils.es;

  public articuloForm: UntypedFormGroup = new UntypedFormGroup({
    nombre: new UntypedFormControl('', Validators.required),
    eliminado: new UntypedFormControl('0'),
    descripcion: new UntypedFormControl(''),
    maceta: new UntypedFormControl(''),
    color: new UntypedFormControl(''),
    tamano: new UntypedFormControl(''),
    peso: new UntypedFormControl(''),
    ean_vivero: new UntypedFormControl(''),
    unidades_caja: new UntypedFormControl(''),
    unidades_piso: new UntypedFormControl(''),
    pisos_cc: new UntypedFormControl(''),
    unidades_cc: new UntypedFormControl(''),
    precio_neto_vivero: new UntypedFormControl(''),
    precio_etiqueta_articulo: new UntypedFormControl(''),
    precio_comision_articulo: new UntypedFormControl(''),
    precio_comision_carro: new UntypedFormControl(''),
    codigo_dehner: new UntypedFormControl(''),
    codigo_schmid: new UntypedFormControl(''),
    codigo_migros: new UntypedFormControl(''),
    codigo_irsslinger: new UntypedFormControl(''),
    codigo_blume2000: new UntypedFormControl(''),
    codigo_landgard: new UntypedFormControl(''),
    codigo_generico: new UntypedFormControl(''),
    archivo1: new UntypedFormControl(''),
    archivo2: new UntypedFormControl(''),
    archivo3: new UntypedFormControl(''),
    archivo4: new UntypedFormControl(''),
    archivo5: new UntypedFormControl(''),
    id_proveedor: new UntypedFormControl(''),
    cantidad_cargada: new UntypedFormControl(''),
    cantidad_reservada: new UntypedFormControl(''),
    fecha_creacion: new UntypedFormControl(new Date()),
    nombre_largo: new UntypedFormControl('')

  });

  public database = "articulos";
  public update: boolean = false;
  public id = "";
  public noGrabar: boolean = false;

  public file: File;
  public file2: File;
  public file3: File;
  public file4: File;
  public file5: File;
  public imagePath;
  public message: string;
  public img: any = "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public imgURL: any =
    "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public imgURL2: any =
    "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public imgURL3: any =
    "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public imgURL4: any =
    "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public imgURL5: any =
    "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public url: string = url + "upload/articulos/";

  constructor(
    private location: Location,
    private messageService: MessageService,
    private genericService: GenericService,
    private _fechaService: FechasService,
    private router: Router,
    private route: ActivatedRoute,
    private _uploadService: UploadService
  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(data => {
      if (data.id == undefined) {
        this.iniciar(null);
      } else {
        this.id = data.id;
        this.update = true;
        this.genericService.getId(this.id, this.database).toPromise().then((resp: any) => {
          this.iniciar(resp[0]);
        }).catch(error => {
          console.log("error", error);
        });
      }
    });
  };

  iniciar(value) {

    let articulo = value;

    if (articulo != null) {
      for (const key in articulo) {

        if (key.localeCompare('id') == 0) {

        } else {
          if (key.includes('fecha')) {
            this.articuloForm.get(key).patchValue(this._fechaService.fechaUpdate(articulo[key]));
          } else {
            this.articuloForm.get(key).patchValue(siEsNull(articulo[key]));
          }
        }

      };

      if (this.articuloForm.get('archivo1').value != null && this.articuloForm.get('archivo1').value.length > 0) {
        this.imgURL = this.url + this.articuloForm.get('archivo1').value;
        // console.log(this.imgURL);

      } else {
        this.imgURL = false;
      }
      if (this.articuloForm.get('archivo2').value != null && this.articuloForm.get('archivo2').value.length > 0) {
        this.imgURL2 = this.url + this.articuloForm.get('archivo2').value;
        // console.log(this.imgURL);

      } else {
        this.imgURL2 = false;
      }
      if (this.articuloForm.get('archivo3').value != null && this.articuloForm.get('archivo3').value.length > 0) {
        this.imgURL3 = this.url + this.articuloForm.get('archivo3').value;
        // console.log(this.imgURL);

      } else {
        this.imgURL3 = false;
      }
      if (this.articuloForm.get('archivo4').value != null && this.articuloForm.get('archivo4').value.length > 0) {
        this.imgURL4 = this.url + this.articuloForm.get('archivo4').value;
        // console.log(this.imgURL);

      } else {
        this.imgURL4 = false;
      }
      if (this.articuloForm.get('archivo5').value != null && this.articuloForm.get('archivo5').value.length > 0) {
        this.imgURL5 = this.url + this.articuloForm.get('archivo5').value;
        // console.log(this.imgURL);

      } else {
        this.imgURL5 = false;
      }



    }
  };

  regresar() {
    this.location.back();
  }

  onSubmit() {

    this.noGrabar = true;
    let data = [{}];
    data[0]['id'] = this.id || '0';

    for (const key in this.articuloForm.value) {

      data[0][key] = this.articuloForm.value[key];

    }

    data[0]['fecha_creacion'] = this._fechaService.arreglarFecha(this.articuloForm.get('fecha_creacion').value);

    if (this.update) {

      this.genericService.update(data[0], this.database).toPromise().then((resp: any) => {

        if (this.file != null) {
          this.fileUpload(this.file, this.id, 'archivo1');
        };
        if (this.file2 != null) {
          this.fileUpload(this.file2, this.id, 'archivo2');
        };
        if (this.file3 != null) {
          this.fileUpload(this.file3, this.id, 'archivo3');
        };
        if (this.file4 != null) {
          this.fileUpload(this.file4, this.id, 'archivo4');
        };
        if (this.file4 != null) {
          this.fileUpload(this.file4, this.id, 'archivo4');
        };
        if (this.file5 != null) {
          this.fileUpload(this.file5, this.id, 'archivo5');
        };

        this.messageService.add({ severity: 'success', summary: 'Registro', detail: 'Registro actualizado correctamente' });



        setTimeout(() => {
          this.router.navigate(['/dashboard/articulos']);
        }, 2000);

      }).catch(error => {
        console.log("error artículos", error);

      });

    } else {


      this.genericService.create(data[0], this.database).toPromise().then((resp: any) => {

        data[0]['id'] = resp.id;
        this.id = resp.id;
        this.genericService.update(data[0], this.database).toPromise();

        if (this.file != null) {
          this.fileUpload(this.file, this.id, 'archivo1');
        };
        if (this.file2 != null) {
          this.fileUpload(this.file2, this.id, 'archivo2');
        };
        if (this.file3 != null) {
          this.fileUpload(this.file3, this.id, 'archivo3');
        };
        if (this.file4 != null) {
          this.fileUpload(this.file4, this.id, 'archivo4');
        };
        if (this.file4 != null) {
          this.fileUpload(this.file4, this.id, 'archivo4');
        };
        if (this.file5 != null) {
          this.fileUpload(this.file5, this.id, 'archivo5');
        };



        this.messageService.add({ severity: 'success', summary: 'Registro', detail: 'Registro creado correctamente' });

        setTimeout(() => {
          this.router.navigate(['/dashboard/articulos']);
        }, 2000);

      }).catch(error => {
        console.log("Error Articulos, error");

      });
    }


  }


  fileUpload(file: File, id: string, name: string) {
    this._uploadService.uploadFilesgeneric(file, id, 'articulos', 'articulos', name).subscribe(
      res => {
        this.messageService.add({
          severity: "info",
          summary: "Registro imagen",
          detail: "Imagen Añadida Correctamente"
        });
        setTimeout(
          function () {
            // this.router.navigate(["dashboard/etiquetas"]);
            this.disableButton = false;
          }.bind(this),
          2000
        );
      },
      error => {
        console.error("Error", error);
      }
    );
  }

  async uploadFile(event, position: number) {
    if (position == 1) { this.file = await this.newPicture(event) };
    if (position == 2) { this.file2 = await this.newPicture(event) };
    if (position == 3) { this.file3 = await this.newPicture(event) };
    if (position == 4) { this.file4 = await this.newPicture(event) };
    if (position == 5) { this.file5 = await this.newPicture(event) };
    let files = event.target.files;
    /*     let numb = this.file.name.lastIndexOf("."); */
    if (files.length === 0) return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = _event => {
      if (position == 1) { this.imgURL = reader.result; };
      if (position == 2) { this.imgURL2 = reader.result; };
      if (position == 3) { this.imgURL3 = reader.result; };
      if (position == 4) { this.imgURL4 = reader.result; };
      if (position == 5) { this.imgURL5 = reader.result; };
    };

  };

  async newPicture(event) {
    //console.log("event",event);
    // console.log("file",event.target.files[0]);
    let file: any = [];

    file = null;
    // this.imageSize=true;
    file = await handleImageUpload(event);
    return file;

  }

  setProveedor(event) {
    this.articuloForm.patchValue({
      id_proveedor: event
    });
  }

  deleteImagen(numero: number) {
    if (numero == 1) {
      this.imgURL = this.img;
      this.file = null;
      this.articuloForm.get('archivo1').patchValue('');
    }
    if (numero == 2) {
      this.imgURL2 = this.img;
      this.file2 = null;
      this.articuloForm.get('archivo2').patchValue('');
    }
    if (numero == 3) {
      this.imgURL3 = this.img;
      this.file3 = null;
      this.articuloForm.get('archivo3').patchValue('');
    }
    if (numero == 4) {
      this.imgURL4 = this.img;
      this.file4 = null;
      this.articuloForm.get('archivo4').patchValue('');
    }
  }

  getImage(event: { base64: string, file: File, numero: number }) {

    if (event.numero == 1) {
      this.imgURL = event.base64;
      this.file = event.file;
    }
    if (event.numero == 2) {
      this.imgURL2 = event.base64;
      this.file2 = event.file;
    }
    if (event.numero == 3) {
      this.imgURL3 = event.base64;
      this.file3 = event.file;
    }
    if (event.numero == 4) {
      this.imgURL4 = event.base64;
      this.file4 = event.file;
    }
    this.showCamera = false;
  }

  openCamera(numero: number) {

    this.fileName = 'imagen' + numero.toString() + '.jpg';
    this.numberPhoto = numero;
    this.showCamera = true;
  }

  closeDialog(event) {
    this.showCamera = false;
  }

}
